/* eslint-disable no-unused-expressions */
export const sendDataToNewRelic = (props) => {
  const {
    appName,
    actionName,
    dealType,
    segment,
    outOfStockItemId
  } = props;
  if (typeof window !== 'undefined') {
    window.newrelic?.addPageAction(actionName, {
      appName,
      dealType,
      segment,
      outOfStockItemId
      // promotionId, // TODO: promo-expansion
    });
  }
};

export const sendErrorsToNewRelic = (props) => {
  const {
    appName,
    actionName,
    errorMessage,
    dealType,
    segment,
    outOfStockItemId
  } = props;
  window.newrelic?.addPageAction(actionName, {
    appName,
    error: errorMessage,
    dealType,
    segment,
    outOfStockItemId
    // promotionId, // TODO: promo-expansion
  });
};
